export default __webpack_public_path__ + "static/media/signin.edbcde6c.png";